import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

// Shared import selector for the SAR comparison tabs. Prefers the final version.
export function ImportPicker({ imports, value, onChange, testId }) {
  if (!imports || imports.length === 0) {
    return <p className="text-sm text-slate-500" data-testid={`${testId}-empty`}>No imports yet — upload a Scheduling Activity Report first.</p>;
  }
  const newestNo = Math.max(...imports.map((i) => i.version_no || 0));
  // A newer upload that has NOT been made the version of record.
  const newerNotFinal = imports.find((i) => (i.version_no || 0) === newestNo && !i.is_final);
  const label = (imp) => {
    if (imp.is_final) return ' · Final (of record)';
    if (imp.status === 'superseded') return ' · Superseded';
    return '';
  };
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[440px]" data-testid={`${testId}-trigger`}>
          <SelectValue placeholder="Choose an import" />
        </SelectTrigger>
        <SelectContent>
          {imports.map((imp) => (
            <SelectItem key={imp.id} value={imp.id} data-testid={`${testId}-item-${imp.id}`}>
              {imp.filename} · v{imp.version_no} · {imp.date_from || '—'} → {imp.date_to || '—'}{label(imp)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {(() => {
        const sel = imports.find((i) => i.id === value);
        if (!sel) return null;
        const showNewerNote = sel.is_final && newerNotFinal && (newerNotFinal.version_no || 0) > (sel.version_no || 0);
        return (
          <div className="flex items-center gap-1 flex-wrap">
            <Badge variant="outline">v{sel.version_no}</Badge>
            {sel.is_final ? (
              <Badge className="bg-indigo-600" data-testid={`${testId}-of-record`}>Final (of record)</Badge>
            ) : sel.status === 'superseded' ? (
              <Badge variant="secondary">Superseded</Badge>
            ) : null}
            {showNewerNote && (
              <Badge variant="outline" className="text-slate-600" data-testid={`${testId}-newer-note`}>
                Newer upload v{newerNotFinal.version_no} exists (not final)
              </Badge>
            )}
          </div>
        );
      })()}
    </div>
  );
}
